import {displayService} from "@/_services/display.service";
import router from "@/router";

import english from '../locales/en.json';
import french from '../locales/fr.json';
import arabic from '../locales/ar.json';

interface CustomVoiceItem {
    queueId: number;
    language: string;
    voiceText: string;
    voiceLabel: string;
}



export function setLocalVoiceBydisplayLang(language: any) {
    console.log("welcome to the voice helper", language)
    let counter = english.Display.Counter
    let number = english.Display.Number
    

   
    const config = JSON.parse(JSON.parse(localStorage.getItem('display') || "").config)
    console.log("config", typeof config.customVoiceCounter)
    console.log("confiiiig", config.customVoiceCounter);

    // checking for customVoiceCounter
    if (config.customVoiceCounter && config.customVoiceCounter !== "[]" && config.customVoiceCounter !== "null" ) {
        console.log("we are here ?? ???")
        const callData =
            typeof config.customVoiceCounter === "string"
                ? JSON.parse(config.customVoiceCounter || "[]")
                : config.customVoiceCounter || [];
        
        const languageVoices = callData.filter((item: CustomVoiceItem) => item.language === language);
        
        if (languageVoices.length > 0) {
            // multiple voice texts for THE SAME language
            const voicePromises = languageVoices.map((item: CustomVoiceItem) => {
                return displayService.getVoiceTelling({
                    text: item.voiceText,
                    language: language,
                }).then(response => ({
                    queueId: item.queueId,
                    displaytxt: item.voiceLabel,
                    voice: response["audio-content"]
                }));
            });

            // Wait for all voice data to be fetched
            Promise.all(voicePromises).then(queueVoices => {
                // Store the first one as default counter
                counter = languageVoices[0].voiceText;
                
                // Get voice for default counter
                displayService.getVoiceTelling({
                    text: counter,
                    language: language,
                }).then(response => {
                    // Store all voice data with their queueIds in localStorage
                    localStorage.setItem('counter', JSON.stringify({
                        voice: response["audio-content"],
                        language: language,
                        queueVoices: queueVoices
                    }));
                });
            });
        }
    }

    // always set default counter and number based on language
    if (!config.customVoiceCounter || config.customVoiceCounter == "[]" || config.customVoiceCounter == "null" || !counter) {
        console.log("hello here ! ")
        switch (language) {
            case 'en':
                counter = english.Display.Counter
                number = english.Display.Number
                break;
            case 'fr':
                
                counter = french.Display.Counter
                number = french.Display.Number
                break;
            case 'ar':
                counter = arabic.Display.Counter
                number = arabic.Display.Number
                break;
            default:
                counter = english.Display.Counter
                number = english.Display.Number
        }
    } else {
        switch (language) {
            case 'en':
                number = english.Display.Number
                break;
            case 'fr':
                number = french.Display.Number
                break;
            case 'ar':
                number = arabic.Display.Number
                break;
            default:
                number = english.Display.Number
        }
    }
    
    console.log("out of the switch", counter, number)

    // override with custom voice if exists
    if (config.voiceNumber && config.voiceNumber!="undefined" && config.voiceNumber !== null) {
        number = config.voiceNumber
    }
    if (config.voiceCounter && config.voiceCounter!="undefined" && config.voiceCounter !== null) {
        counter = config.voiceCounter
    }
    console.log("text config", config.voiceNumber, config.voiceCounter)

    console.log("out of the end if 2", counter, number)

    // process and store both counter and number voices
    const words = [counter, number]
    let processedCount = 0;

    console.log("words", words)

    words.forEach((word, key) => {
        displayService.getVoiceTelling({
            text: word,
            language: language,
        })
            .then(function (response) {
                localStorage.setItem(
                    key == 0 ? 'counter' : 'number',
                    JSON.stringify({
                        voice: response["audio-content"],
                        language: language,
                    })
                );
                processedCount++;
                
                
                if (processedCount === words.length) {
                    setInterval(() => {
                        location.reload()
                    }, 2000)
                }
            });
    });
}